<!-- Button trigger modal -->
<div style="text-align: center; margin-top: 10px;">
    <button *ngIf="contractData && role == 'admin'" [disabled]="contractData.paid" type="button" class="btn btn-dark" data-toggle="modal" aria-label="Left Align" data-target="#deleteContractModal">
            Borrar contrato 
    </button>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="deleteContractModal" tabindex="-1" role="dialog" aria-labelledby="deleteContractModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteContractModalLabel">Borrar Contrato</h5>
                <button type="button"  class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="contractData">
                <p>Está seleccionando borrar el contrato #<strong>{{ contractData.id }}</strong>. La información del contrato y los pagos atados serán removidos permanentemente.</p>
                <p>Para confirmar esto, seleccione borrar nuevamente.</p>
            </div>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                Error intente luego...
            </div>
            <div class="modal-footer">
            
                <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" (click)="deleteContract()" class="btn btn-danger">Borrar</button>
            </div>
       
        </div>
    </div>
    </div>